import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementSpendTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "procurement.spend-trend",
  name: "Purchase spend trend",
  description: "Purchase spend trend across the selected period.",
  apps: [
    "home",
    "procurement",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Spend",
        query: {
          version: 1,
          source: "procurement.purchases",
          ...period(30),
          select: [
            {
              type: "field",
              field: "created_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "total",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "created_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#d63939",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Purchase spend trend",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$92,750",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
